import { render, staticRenderFns } from "./deviceinfo.vue?vue&type=template&id=f5c1c7e6&scoped=true"
import script from "./deviceinfo.vue?vue&type=script&lang=js"
export * from "./deviceinfo.vue?vue&type=script&lang=js"
import style0 from "./deviceinfo.vue?vue&type=style&index=0&id=f5c1c7e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5c1c7e6",
  null
  
)

export default component.exports